var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgChevronDown = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.72 15.78C12.5795 15.9207 12.3889 15.9998 12.19 16H11.81C11.6116 15.9977 11.4217 15.9189 11.28 15.78L6.15 10.64C6.05535 10.5461 6.00211 10.4183 6.00211 10.285C6.00211 10.1517 6.05535 10.0239 6.15 9.92998L6.86 9.21998C6.95217 9.12592 7.07832 9.07291 7.21 9.07291C7.34169 9.07291 7.46784 9.12592 7.56 9.21998L12 13.67L16.44 9.21998C16.5339 9.12533 16.6617 9.07208 16.795 9.07208C16.9283 9.07208 17.0561 9.12533 17.15 9.21998L17.85 9.92998C17.9447 10.0239 17.9979 10.1517 17.9979 10.285C17.9979 10.4183 17.9447 10.5461 17.85 10.64L12.72 15.78Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChevronDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chevron_down.2a3e5ddf.svg";
export { ForwardRef as ReactComponent };